import React from 'react'

//Node Modules
import { domToReact } from 'html-react-parser'

export default (node:any, params:any, options:any) => {
  return <div>{domToReact(node.children, options)}</div>
}